import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { expressQuerySelector, getParentWithClassName, expressQuerySelectorAll } from "../../common/html";
import { createHighlightedTiles } from "../organisms/highlighted-tiles";
import { createTruncate } from "../technical/truncate";
import { initColorSwap } from "../technical/color-swap";
import { initVideoPlayer } from "../technical/video-player";
import { createProductGrids } from "../technical/product-grids";
import { createImageDescription } from "../molecules/image-description";
import { getWishlistItems } from "../../services/wishlist-service";

window.addEventListener("DOMContentLoaded", async () => {
	window.showMores = [];
	// load the wishlistItems
	window.wishlist = await getWishlistItems();
	const imageDescriptions = expressQuerySelectorAll<HTMLElement>(document, ".technical-image-description");

	// Initialize the image descriptions
	imageDescriptions.forEach((el) => createImageDescription(el));

	createGeneralPageEventsAndComponents();

	// init highlighted tiles
	const highlightedTilesEl = expressQuerySelector<HTMLElement>(document, ".technical-highlighted-tiles", false);
	if (highlightedTilesEl) createHighlightedTiles(highlightedTilesEl);

	const headerComponents = expressQuerySelectorAll<HTMLElement>(document, ".technical-header-component");
	headerComponents.forEach((header) => {
		const truncateEl = expressQuerySelector<HTMLElement>(header, ".technical-shave", false);
		if (!truncateEl) return;
		createTruncate(truncateEl, { lines: 2 });
	});

	// Init product grids
	const grids = expressQuerySelectorAll<HTMLElement>(document, ".technical-product-grid");
	if (grids) createProductGrids(grids);

	const colorSwapEls = expressQuerySelectorAll<HTMLElement>(document, ".technical-color-swap");
	colorSwapEls.forEach((el) => {
		if (!getParentWithClassName(el, "technical-product-grid-content"))
			initColorSwap(el, expressQuerySelector<HTMLElement>(el, ".m-product__button", false));
	});

	const videoTileEls = expressQuerySelectorAll<HTMLElement>(document, ".technical-video-tile");
	videoTileEls.forEach((el) => {
		initVideoPlayer(el);
	});
});
